import Vue from 'vue';
import Router from 'vue-router';
import Search from './components/Search.vue';
import SearchAPI from './components/SearchAPI';

const searchSettings = window.drupalSettings.searchSettings

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: searchSettings.search.path,
      name: 'search',
      component: Search
    },
    {
      path: '/search/node',
      redirect: searchSettings.search.path,
    },
    {
      path: searchSettings.research_and_reports.path,
      name: 'research_and_reports',
      component: Search
    },
    {
      path: searchSettings.school_me.path,
      name: 'school_me',
      component: Search
    },
    {
      path: searchSettings.resource_library.path,
      name: 'resource_library',
      component: Search
    },
    {
      path: searchSettings.new_from_nea.path,
      name: 'new_from_nea',
      component: Search
    },
    {
      path: searchSettings.tools_and_tips.path,
      name: 'tools_and_tips',
      component: Search
    },
    {
      path: searchSettings.professional_learning_resources.path,
      name: 'professional_learning_resources',
      component: Search
    },
    {
      path: searchSettings.standard_events.path,
      name: 'standard_events',
      component: SearchAPI
    },
    {
      path: searchSettings.ra_agenda.path,
      name: 'ra_agenda',
      component: SearchAPI
    },
    {
      path: searchSettings.ra_calendar.path,
      name: 'ra_calendar',
      component: SearchAPI
    },
    {
      path: searchSettings.business_items.path,
      name: 'business_items',
      component: SearchAPI
    },
    {
      path: searchSettings.federal_education_funding.path,
      name: 'federal_education_funding',
      component: Search
    },
    {
      path: searchSettings.take_action.path,
      name: 'take_action',
      component: Search
    },
    {
      path: searchSettings.bills.path,
      name: 'bills',
      component: Search
    },
    {
      path: searchSettings.letters_and_testimony.path,
      name: 'letters_and_testimony',
      component: Search
    },
    {
      path: '/professional-excellence/student-engagement/read-across-america/find-your-book',
      name: 'find_your_book',
      component: Search
    },
    {
      path: searchSettings.edjustice_take_action.path,
      name: 'edjustice_take_action',
      component: Search
    },
    {
      path: searchSettings.edjustice_resource_library.path,
      name: 'edjustice_resource_library',
      component: Search
    },
    {
      path: searchSettings.edjustice_see_the_latest.path,
      name: 'edjustice_see_the_latest',
      component: Search
    },
    {
      path: searchSettings.nea_today_news_and_articles.path, // is same as all_news_and_articles
      name: 'nea_today_news_and_articles',
      component: Search
    },
  ],
});
